import { ListPage, RefreshButton } from '@skylabs-digital/backoffice-kit';
import { appsApi } from '../api/apps.api';
import { AppList } from '../components/apps/AppList';

export function AppsPage() {
  const { data: apps, loading, error, refetch } = appsApi.useList();
  return (
    <ListPage
      title="Apps"
      description="Every app that stores files in Fisto. Apps and their prefix rules are declared by each product’s cac/stack.ts."
      actions={<RefreshButton onRefresh={refetch} isRefreshing={loading} />}
    >
      <AppList apps={apps ?? []} loading={loading} error={error as Error | null | undefined} />
    </ListPage>
  );
}
